__turbopack_context__.v({
  "background": "footer-module__QXRxYG__background",
  "bottom": "footer-module__QXRxYG__bottom",
  "brandColumn": "footer-module__QXRxYG__brandColumn",
  "captchaWrap": "footer-module__QXRxYG__captchaWrap",
  "columnTitle": "footer-module__QXRxYG__columnTitle",
  "companyInfo": "footer-module__QXRxYG__companyInfo",
  "companyName": "footer-module__QXRxYG__companyName",
  "consent": "footer-module__QXRxYG__consent",
  "contactLink": "footer-module__QXRxYG__contactLink",
  "copyright": "footer-module__QXRxYG__copyright",
  "copyrightLink": "footer-module__QXRxYG__copyrightLink",
  "description": "footer-module__QXRxYG__description",
  "footer": "footer-module__QXRxYG__footer",
  "footerLink": "footer-module__QXRxYG__footerLink",
  "formError": "footer-module__QXRxYG__formError",
  "honeypot": "footer-module__QXRxYG__honeypot",
  "inner": "footer-module__QXRxYG__inner",
  "linkList": "footer-module__QXRxYG__linkList",
  "linksColumn": "footer-module__QXRxYG__linksColumn",
  "logo": "footer-module__QXRxYG__logo",
  "logoLink": "footer-module__QXRxYG__logoLink",
  "newsletterButton": "footer-module__QXRxYG__newsletterButton",
  "newsletterColumn": "footer-module__QXRxYG__newsletterColumn",
  "newsletterForm": "footer-module__QXRxYG__newsletterForm",
  "newsletterInput": "footer-module__QXRxYG__newsletterInput",
  "srOnly": "footer-module__QXRxYG__srOnly",
  "success": "footer-module__QXRxYG__success",
  "wordmark": "footer-module__QXRxYG__wordmark",
});
